import generator from './generator';

export default {
  name: 'PiQrcode',

  props: {
    text: {
      type: String,
    },

    color: {
      type: String,
      default: 'black',
    },

    cellSize: {
      type: Number,
      default: 4,
    },

    errorCorrectionLevel: {
      type: String,
      default: 'M',
    },

    logo: {
      type: String,
    },

    logoScale: {
      type: Number,
      default: 0.25,
    },
  },

  data() {
    return {
      imgData: '',
    };
  },

  render(h) {
    return h('img', {
      attrs: {
        src: this.imgData,
      },
    });
  },

  created() {
    ['text', 'color', 'cellSize', 'logo'].forEach(field => {
      this.$watch(field, this.updateImg);
    });
  },

  mounted() {
    this.updateImg();
  },

  methods: {
    updateImg() {
      const qr = generator({
        text: this.text,
        typeNumber: 0,
        errorCorrectionLevel: this.errorCorrectionLevel,
      });
      const ps = this.cellSize;
      const moduleCount = qr.getModuleCount();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const w = ps * moduleCount;

      ctx.canvas.width = w;
      ctx.canvas.height = w;
      ctx.fillStyle = this.color;
      for (let r = 0; r < moduleCount; r += 1) {
        for (let c = 0; c < moduleCount; c += 1) {
          if (qr.isDark(r, c)) {
            ctx.fillRect(c * ps, r * ps, ps, ps);
          }
        }
      }

      if (this.logo) {
        const logoImg = new Image();
        // 支持跨域图片载入
        logoImg.setAttribute('crossOrigin', 'Anonymous');
        logoImg.onload = () => {
          let logoWidth = w * this.logoScale;
          let logoHeight = w * this.logoScale;

          const sx = w / 2 - logoWidth / 2;
          const sy = w / 2 - logoHeight / 2;

          ctx.drawImage(logoImg, sx, sy, logoWidth, logoHeight);

          this.imgData = canvas.toDataURL('image/gif');
        };
        logoImg.onerror = e => {
          console.error(e.message);
        };

        logoImg.src = this.logo;
      } else {
        this.imgData = canvas.toDataURL('image/gif');
      }
    },
  },
};
